/**
 * components/toastHost.web.tsx
 * Web toast host. react-native-web's Modal renders in a body portal at a high
 * z-index, so a toast in the normal tree can sit behind open modals. We portal
 * the toast into its own body-level layer above that, so toasts (incl. in-modal
 * validation) always show on top — app-wide. (Ported from SK Catalog.)
 */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Toast from 'react-native-toast-message';
import { toastConfig } from './toastConfig';

export default function ToastHost() {
  const elRef = useRef<HTMLDivElement | null>(null);
  if (!elRef.current && typeof document !== 'undefined') {
    const d = document.createElement('div');
    d.style.position = 'fixed';
    d.style.left = '0';
    d.style.right = '0';
    d.style.top = '0';
    d.style.bottom = '0';
    d.style.zIndex = '2147483646'; // above rn-web Modal
    d.style.pointerEvents = 'none'; // never block the UI; toasts auto-hide
    elRef.current = d;
  }

  useEffect(() => {
    const el = elRef.current;
    if (!el) return undefined;
    document.body.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  if (!elRef.current) return null;
  return createPortal(<Toast config={toastConfig} topOffset={28} />, elRef.current);
}
